/* eslint-disable jsx-a11y/anchor-is-valid */
import { format, isSameDay } from 'date-fns'
import es from 'date-fns/locale/es'
import { FC, useEffect, useMemo, useState } from 'react'
import { Column } from 'react-table'
import Swal from 'sweetalert2'
import { KTCard } from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
} from '../../../../../../components/UI'
import { KTableProvider, useKTable } from '../../../../../../contexts/KTableProvider'
import { useLimpieza } from '../../../../../../hooks/useLimpieza'
import { ServiceSchedulingDto } from '../../../../model/cleaningSchedule.model'
import { CLEANING_SCHEDULE_SERVICES } from '../../../../services'
import { ModalAddSchedule } from '../modal/add-schedule'
import { ShowSnackBar } from '../../../../../../util/functions'
import { SCHEDULE_ACTIVITY_SERVICES } from '../../../../services/schedule-activity.service'

const TableSchedulesByActivity: FC = () => {
  const { data, setData, setPagination, loading, setLoading, pagination, selected, clearSelected } =
    useKTable()
  const [showModalNew, setShowModalNew] = useState(false)
  const { currentTabItem } = useLimpieza()

  const getSchedulesByActivityList = async () => {
    try {
      clearSelected()
      setLoading(true)
      const { data: response } = await CLEANING_SCHEDULE_SERVICES.filterCleaningSchedule({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ActividadConfiguracionId: currentTabItem.idToEdit,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getSchedulesByActivityList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  // useEffect(() => {
  //   getSchedulesByActivityList()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentTabItem.idToEdit])

  const columns: Column<ServiceSchedulingDto>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelect={true} />,
        id: 'selection',
        Cell: ({ ...props }) => (
          <KTableSelectionCell id={props.data[props.row.index].Id} />
        ),
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Campamento' />,
        accessor: 'Campamento',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura' />,
        accessor: 'Nomenclatura',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='TipoEdificacion' />,
        accessor: 'TipoEdificacion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='TipoRepeticion' />,
        accessor: 'TipoRepeticion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha - Hora'
            className='d-flex justify-content-center flex-shrink-0'
          />
        ),
        id: 'fechas',
        Cell: ({ row }) => {
          const { FechaInicio, FechaFin, HoraInicio } = row.original || {}

          if (!FechaInicio) {
            return <div className='text-center text-muted'>Sin fecha</div>
          }

          const fechaInicio = new Date(FechaInicio)
          const fechaFin = FechaFin ? new Date(FechaFin) : null

          if (HoraInicio) {
            const [h = 0, m = 0, s = 0] = HoraInicio.split(':')
            fechaInicio.setHours(Number(h), Number(m), Number(s))
          }

          const mismoDia = fechaFin && isSameDay(fechaInicio, fechaFin)

          return (
            <div className='d-flex justify-content-center flex-shrink-0'>
              {fechaFin
                ? mismoDia
                  ? format(fechaInicio, 'dd MMM yyyy • HH:mm', { locale: es })
                  : `Del ${format(fechaInicio, 'dd MMM yyyy HH:mm', { locale: es })} al ${format(
                    fechaFin,
                    'dd MMM yyyy',
                    { locale: es },
                  )}`
                : format(fechaInicio, 'dd MMM yyyy HH:mm', { locale: es })}
            </div>
          )
        },
      },
    ],
    [selected],
  )

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        const { data: response } = await SCHEDULE_ACTIVITY_SERVICES.deleteActivitySettings({
          ServiceSchedulingId: selected.map(x => x.toString()),
          ActividadConfiguracionId: [currentTabItem.idToEdit],
        })
        if (!response.error) {
          ShowSnackBar('Se eliminó satisfactoriamente')
        } else {
          ShowSnackBar(response.message, 'error')
        }
        getSchedulesByActivityList()
        setLoading(false)
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleNew = () => {
    setShowModalNew(true)
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex justify-content-end p-2 me-5'>
          <button type='button' className='btn btn-success me-3' onClick={handleNew}>
            Agregar Programación
          </button>
          <button
            type='button'
            className='btn btn-primary me-3'
            disabled={selected.length < 1}
            onClick={handleDelete}
          >
            Eliminar
          </button>
        </div>
        <KTable data={data} columns={columns as any} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <KTableProvider key='modal'>
          <ModalAddSchedule
            show={showModalNew}
            setShow={setShowModalNew}
            activityConfigId={currentTabItem.idToEdit}
            campamentoId={currentTabItem.detailRow?.CampamentoId}
            schedules={currentTabItem.detailRow?.Programaciones}
            refreshTable={getSchedulesByActivityList}
          />
        </KTableProvider>
      </KTCard>
    </>
  )
}

const TableSchedulesByActivityWrapper = () => {
  return (
    <KTableProvider key='table'>
      <TableSchedulesByActivity />
    </KTableProvider>
  )
}
export { TableSchedulesByActivityWrapper }
